import { render, staticRenderFns } from "./Scale.vue?vue&type=template&id=37b17c6a&scoped=true"
import script from "./Scale.vue?vue&type=script&lang=js"
export * from "./Scale.vue?vue&type=script&lang=js"
import style0 from "./Scale.vue?vue&type=style&index=0&id=37b17c6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b17c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b17c6a')) {
      api.createRecord('37b17c6a', component.options)
    } else {
      api.reload('37b17c6a', component.options)
    }
    module.hot.accept("./Scale.vue?vue&type=template&id=37b17c6a&scoped=true", function () {
      api.rerender('37b17c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/Scale.vue"
export default component.exports